import { set, isNil } from 'lodash'
import createStyles from './styles'
import variant from './specs/variant'
import textSizeForControlHeight from './specs/textSizeForControlHeight'

const INSTALLED_THEMES = []
const INSTALLED_SPECS = {
  'base.variant': variant,

  'cmp.base.textSizeForControlHeight': textSizeForControlHeight,
  'cmp.debug': {
    grid: {
      background: 'transparent url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAFElEQVR4AWPAC97/9x0eCsAEPgwAVLshdpENIxcAAAAASUVORK5CYII=) repeat top left',
    },
    outline: {
      outline: '1px solid',
    },
  },
}

export function registerSpec(specPaths, spec) {
  if (isNil(spec)) {
    throw new Error(`Register spec failed with ${specPaths}`)
  }
  INSTALLED_THEMES.forEach(theme => {
    set(theme, specPaths, spec)
    // incr theme version, indicate theme has changed
    const nameList = theme.name.split('@') || ['nan', '1.0.0']
    const lst = (nameList[1] || ['1.0.0']).split('.').map(Number)
    lst[lst.length - 1] += 1
    theme.name = `${nameList[0]}@${lst.join('.')}`
  })

  INSTALLED_SPECS[specPaths] = spec
  // window.INSTALLED_THEMES = INSTALLED_THEMES
}

export function createTheme(
  styleConfig = {},
) {
  const styles = createStyles(styleConfig)

  const theme = {
    ...styles,
  }

  Object.keys(INSTALLED_SPECS).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(INSTALLED_SPECS, key)) {
      set(theme, key, INSTALLED_SPECS[key])
    }
  })

  INSTALLED_THEMES.push(theme)
  return theme
}
